import useMentorPrompts from '../../hooks/api/mentors/useMentorPrompts';
import { userIsStudent } from '../../utils/shared';
import { SidebarBottomLink } from './sidebar-bottom-link';

export function PromptGalleryLink({ mentorId, url }) {
  const { suggestedPrompts } = useMentorPrompts(mentorId);

  const promptGalleryLinkDetails = {
    url,
    label: 'Prompt Gallery',
    icon: '/images/terminal.svg',
  };

  if (userIsStudent() && suggestedPrompts?.length === 0) {
    return null;
  }

  return <SidebarBottomLink {...promptGalleryLinkDetails} />;
}
